import { CREATE_SOURCE_NAME_REQUIRED_ERROR } from "@/pages/sources/components/create/sources/constants";
import type { CreateSourceState } from "@/pages/sources/components/create/sources/types";

export function isCreateSourceValueProvided(value: string | undefined): boolean {
  if (!value) {
    return false;
  }

  return value.trim().length > 0;
}

export function isCreateSourceNameProvided(state: Pick<CreateSourceState, "sourceName">): boolean {
  return isCreateSourceValueProvided(state.sourceName);
}

export function getCreateSourceNameError(
  state: Pick<CreateSourceState, "shouldShowErrors" | "sourceName">,
): string | null {
  if (!state.shouldShowErrors) {
    return null;
  }

  return isCreateSourceNameProvided(state) ? null : CREATE_SOURCE_NAME_REQUIRED_ERROR;
}
